import {IsEmail, IsNotEmpty, IsString} from '@pristine-ts/class-validator';
import {EmployeeRoleEnum} from '../enums/employee-role.enum';
import {ErrorMessageBuilder} from '../builders/error-message.builder';
import {translationBaseKey} from '../decorators/translation-base-key.decorator';
import {advancedFormControl, FormControlTypeEnum} from "@magieno/common";

@translationBaseKey('invite-creation-options')
export class InviteCreationOptions {
  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Adresse courriel',
        en: 'Email',
      },
    },
    type: FormControlTypeEnum.Input
  })
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsEmail({ buildErrorMessage: ErrorMessageBuilder.build })
  email: string;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Rôle',
        en: 'Role',
      },
    },
    items: [
      {
        label: {
          fr: 'Admin',
          en: 'Admin',
        },
        id: EmployeeRoleEnum.Admin,
      },
      {
        label: {
          fr: 'Comptable',
          en: 'Accountant',
        },
        id: EmployeeRoleEnum.Accountant,
      },
    ],
    type: FormControlTypeEnum.Select
  })
  //@IsEnum({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
    // todo validate why value is not recognized as enum
    // @IsEnum(EmployeeRoleEnum)
  role: EmployeeRoleEnum;
}
